<template>
  <div>
    <o-section @click.native="$emit('editLocation')">
      <o-text-input
        icon="location"
        label="Locatie"
        value="Gent"
        :readonly="true"
        :chevron="true"
      />
    </o-section>
    <o-section>
      <o-text-input label="Standplaats">
        <div class="u-flex">
          <o-text-input
            icon="brands/cambio"
            class="u-flex__flexible"
            value="Gent-Dampoort"
            :readonly="true"
            :chevron="!active"
            @click.native="$emit('editStand')"
          />
          <o-icon
            icon="info"
            class="c-textinput__info"
            @click.native="$emit('standInfo')"
          />
        </div>
      </o-text-input>
    </o-section>
    <o-section>
      <o-text-input label="Wagenklasse">
        <div class="u-flex">
          <o-text-input
            icon="car"
            class="u-flex__flexible"
            value="S Micro autom. - 2 + 2 pl."
            :readonly="true"
            :chevron="!active"
            @click.native="$emit('editKlasse')"
          />
          <o-icon
            icon="info"
            class="c-textinput__info"
            @click.native="$emit('klasseInfo')"
          />
        </div>
      </o-text-input>
    </o-section>
    <o-section @click.native="edit ? $emit('editTime') : null">
      <o-text-input label="Vertrek">
        <div class="u-flex">
          <o-text-input
            icon="date"
            class="u-flex__flexible"
            value="2019-06-24"
            :type="edit ? 'text' : 'date'"
            :readonly="edit"
          />
          <o-text-input
            icon="clock"
            class="u-flex__flexible"
            value="10:00"
            :type="edit ? 'text' : 'time'"
            :readonly="edit"
            :chevron="edit && !active"
          />
        </div>
      </o-text-input>
    </o-section>
    <o-section @click.native="edit ? $emit('editTime') : null">
      <o-text-input label="Aankomst">
        <div class="u-flex">
          <o-text-input
            icon="date"
            class="u-flex__flexible"
            value="2019-06-24"
            :type="edit ? 'text' : 'date'"
            :readonly="edit"
          />
          <o-text-input
            icon="clock"
            class="u-flex__flexible"
            value="17:00"
            :type="edit ? 'text' : 'time'"
            :readonly="edit"
            :chevron="edit"
          />
        </div>
      </o-text-input>
    </o-section>
    <o-section v-if="edit" @click.native="$emit('editDistance')">
      <o-text-input
        icon="destination"
        label="Gewenste reikweidte"
        value="25 km"
        :readonly="true"
        :chevron="!active"
      />
    </o-section>
    <o-section @click.native="$emit('editOptions')">
      <o-text-input
        icon="airco"
        label="Toebehoren"
        value="Kinderstoel"
        :readonly="true"
        :chevron="!active"
      />
    </o-section>
    <o-section v-if="edit" @click.native="$emit('editInsurance')">
      <o-text-input
        icon="lock"
        label="Verzekering"
        value="Volledig verzekerd"
        :readonly="true"
        :chevron="!active"
      />
    </o-section>
    <o-section v-if="edit && !active">
      <o-button
        :is-dangerous="true"
        label="Reservatie annuleren"
        @click="$emit('cancel')"
      />
    </o-section>
  </div>
</template>

<script>
import OListItem from '@/components/base/OListItem.vue'
import OTextInput from '@/components/base/OTextInput.vue'
export default {
  name: 'OCambioReservationForm',
  components: { OTextInput, OListItem },
  props: {
    edit: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    }
  }
}
</script>
